export const DEFAULT_PAGE_SIZE = 20
export const PAGE_SIZE_OPTIONS = [10, 20, 50] as const
export const DEFAULT_FETCH_LIMIT = 100
